// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {useLocation} from 'react-router';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './vs_toolip.module.less';
import {Faq_section} from '../toolip/faq_section';
import {Input} from '../../../../hola/pub/lib/input';
import {Button} from '../../../../hola/pub/lib/button';
import {Textarea} from '../../../../hola/pub/lib/textarea';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';

export interface i_general_faq_props {
    title?: string;
    title_tag?: string;
    custom_questions?: Array<{
        quest: string;
        ans: JSX.Element | Array<{name: string; url: string}>;
    }>;
}
interface i_general_faq_editor_props {
    value:i_general_faq_props;
    on_change: (v:i_general_faq_props)=>void
}

export const General_faq = (props: i_general_faq_props)=>{
    const {title, title_tag} = props;
    const {theme} = useContext(Settings_context);
    const {pathname} = useLocation();
    const get_data_id =()=>`schema-faqs-${pathname}`;
    const {data} = use_data_provider(get_data_id);
    const is_editor_change =
        JSON.stringify(data?.result?.data) !==
          JSON.stringify(props.custom_questions);

    return <div className={cn(styles.faq, theme.container)}>
      <Dynamic_heading tag={title_tag || 'h2'}>{title || 'Some FAQs'}
      </Dynamic_heading>
      <Faq_section
        custom_questions={is_editor_change
          ? props.custom_questions : data?.result?.data}
        no_title
        color='transparent'
      />
    </div>;
};

export const General_faq_editor = (props:i_general_faq_editor_props)=>{
    const {value, on_change} = props;
    const questions = value.custom_questions || [];
    const update_question = (index: number, key: string, new_val: string)=>{
      const updated = [...questions];
      updated[index] = {
          ...updated[index],
          [key]: new_val
      };
      on_change({...value, custom_questions: updated});
    };
    const add_question = ()=>{
        const updated = [...questions, {quest: '', ans: []}];
        on_change({...value, custom_questions: updated});
    };
    const remove_question = (index: number)=>{
        const updated = questions.filter((_, i)=>i!==index);
        on_change({...value, custom_questions: updated});
    };
    return <div>
      <Input
        value={value.title || ''}
        on_change={v=>on_change({...value, title: v})}
        label='Section Title'
      />
      <Title_header_select value={value.title_tag} on_select={v=>
        on_change({...value, title_tag: v})}/>
      {questions.map((q, i)=>
        <div key={i} style={{border: '1px solid #ccc', padding: '8px',
          marginBottom: '8px'}}>
          <Input
            value={q.quest}
            on_change={v=>update_question(i, 'quest', v)}
            label={`Question ${i+1}`}
          />
          <Textarea
            value={q.ans + '' || ''}
            on_change={v=>update_question(i, 'ans', v)}
            placeholder={`Answer ${i+1}`}
          />
          <Button caption='Remove' on_click={()=>remove_question(i)}
            color='light_red' round={false}/>
        </div>
      )}
      <Button caption='Add Question' on_click={add_question}
        color='blue' round={false}/>
    </div>;
};
